import { Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';
import { MarkerInfoModel } from '../models/marker-info.model';
import { GoogleService } from '../services/google.service';
import { Library } from '@googlemaps/js-api-loader';

@Component({
  selector: 'de-google-map',
  templateUrl: './de-google-map.component.html',
  styleUrls: ['./de-google-map.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class DeGoogleMapComponent {
  @ViewChild(MapInfoWindow) infoWindow!: MapInfoWindow;
  private _center: { lat: number, lng: number };


  get center(): { lat: number, lng: number } {
    if (this._center) {
      return this._center;
    } else {
      if (this.markers.length > 0) {
        return { lat: this.markers[0].position.lat, lng: this.markers[0].position.lng };
      }
    }
  }
  @Input()
  set center(value: { lat: number, lng: number }) {
    this._center = value;
  }

  selectedMarker: MarkerInfoModel = null;

  @Input()
  markers: MarkerInfoModel[] = [];
  isReady: boolean;

  constructor(private googleService: GoogleService) {

    this.googleService.load("maps").subscribe(() => {
      this.isReady = true;

    });
  }
  onMarkerClick(mapMarker: MapMarker, marker: MarkerInfoModel) {
    this.selectedMarker = marker;
    this.infoWindow.open(mapMarker);
  }

}
